<div class="sepenkey-header" [class.header-sidebar-collapsed]="isSideNavExpCol">
  <!-- Global Search — tenant-gated via tblPageFields row 'globalSearch' on
       HeaderPage. Hidden when the row is absent, so clients that don't need
       it never see it. -->
  <app-global-search *ngIf="showGlobalSearch"></app-global-search>

  <!-- Right side: Language, Currency, Profile -->
  <!-- Job Queue and Notifications buttons removed pending wiring; restore from git history when ready. -->
  <div class="sk-header-right">

    <!-- Language Switcher — tenant-gated via tblConfiguration.LanguageTranslation
         (parity with Angular 8). Flip settingValue to 'False' on the tenant DB
         to hide on both apps. See showLanguageSwitcher in header.component.ts. -->
    <div class="sk-header-lang-wrap" *ngIf="showLanguageSwitcher">
      <button
        type="button"
        class="sk-header-lang-btn"
        (click)="toggleLangDropdown()"
        [class.sk-header-lang-btn--active]="langDropdownOpen"
        [attr.aria-label]="'Switch language' | translate"
      >
        <mat-icon class="sk-header-lang-globe">language</mat-icon>
        <span class="sk-header-lang-code">{{ selectedLangName }}</span>
        <mat-icon class="sk-header-lang-chevron" [class.sk-header-lang-chevron--open]="langDropdownOpen">
          keyboard_arrow_down
        </mat-icon>
      </button>

      <!-- Backdrop -->
      <div
        class="sk-header-lang-backdrop"
        *ngIf="langDropdownOpen"
        (click)="closeLangDropdown()"
      ></div>

      <!-- Dropdown -->
      <div class="sk-header-lang-dropdown" *ngIf="langDropdownOpen" role="menu">
        <div class="sk-header-lang-dropdown-header">
          <mat-icon class="sk-header-lang-dropdown-icon">translate</mat-icon>
          <span>{{ 'Language' | translate }}</span>
        </div>
        <div class="sk-header-lang-dropdown-divider"></div>
        <button
          *ngFor="let lang of languages"
          type="button"
          class="sk-header-lang-option"
          [class.sk-header-lang-option--active]="selectedLang === lang.code"
          (click)="changeLanguage(lang.code)"
          role="menuitem"
        >
          <span class="sk-header-lang-option-badge">{{ lang.label }}</span>
          <span class="sk-header-lang-option-name">{{ lang.name }}</span>
          <mat-icon class="sk-header-lang-option-check" *ngIf="selectedLang === lang.code">check</mat-icon>
        </button>
      </div>
    </div>

    <!-- Currency Switcher — tenant-gated via tblConfiguration.CurrencyConversion
         (parity with Angular 8, which gates purely on currFlag with no list
         guard). Flip settingValue to 'False' on the tenant DB to hide on both
         apps. See showCurrencySwitcher in header.ts. -->
    <div class="sk-header-curr-wrap" *ngIf="showCurrencySwitcher">
      <button
        type="button"
        class="sk-header-curr-btn"
        (click)="toggleCurrDropdown()"
        [class.sk-header-curr-btn--active]="currDropdownOpen"
        [attr.aria-label]="'Switch currency' | translate"
      >
        <mat-icon class="sk-header-curr-icon">payments</mat-icon>
        <span class="sk-header-curr-code">{{ selectedCurrName }}</span>
        <mat-icon class="sk-header-curr-chevron" [class.sk-header-curr-chevron--open]="currDropdownOpen">
          keyboard_arrow_down
        </mat-icon>
      </button>

      <!-- Backdrop -->
      <div
        class="sk-header-curr-backdrop"
        *ngIf="currDropdownOpen"
        (click)="closeCurrDropdown()"
      ></div>

      <!-- Dropdown -->
      <div class="sk-header-curr-dropdown" *ngIf="currDropdownOpen" role="menu">
        <div class="sk-header-curr-dropdown-header">
          <mat-icon class="sk-header-curr-dropdown-icon">payments</mat-icon>
          <span>{{ 'Currency' | translate }}</span>
        </div>
        <div class="sk-header-curr-dropdown-divider"></div>
        <button
          *ngFor="let curr of currencies"
          type="button"
          class="sk-header-curr-option"
          [class.sk-header-curr-option--active]="selectedCurr === curr.Curr_Code"
          (click)="changeCurrency(curr.Curr_Code)"
          role="menuitem"
        >
          <span class="sk-header-curr-option-badge">{{ curr.Curr_Code }}</span>
          <span class="sk-header-curr-option-name">{{ curr.Curr_Name }}</span>
          <mat-icon class="sk-header-curr-option-check" *ngIf="selectedCurr === curr.Curr_Code">check</mat-icon>
        </button>
      </div>
    </div>

    <!-- PoC tier bar — hides itself for non-PoC tenants -->
    <app-poc-tier-bar></app-poc-tier-bar>

    <!-- Notification center (US #9575): bell + unread badge + dropdown panel.
         Badge = unread events + open tasks; muted (no badge) when zero.
         Clicking opens the center; each item links to its target.
         Tenant-gated via tblPageFields row 'notificationCenter' on HeaderPage.
         SP_Get_PageData filters Status=1, so flip Status to 0 on the row to
         hide. refreshNotifCount() also short-circuits when this is off. -->
    <div class="sk-header-notif-wrap" *ngIf="showNotificationCenter">
      <button
        type="button"
        class="sk-header-notif-btn"
        [class.sk-header-notif-btn--muted]="notifUnreadCount === 0"
        [class.sk-header-notif-btn--active]="notifOpen"
        (click)="toggleNotifPanel()"
        [attr.aria-label]="'Notifications' | translate"
      >
        <mat-icon
          [matBadge]="notifUnreadCount"
          [matBadgeHidden]="notifUnreadCount === 0"
          [matBadgeDescription]="notifUnreadCount + ' ' + ('unread notifications' | translate)"
          matBadgeColor="warn"
          matBadgeSize="small"
          matBadgeOverlap="true"
          aria-hidden="false"
        >notifications</mat-icon>
      </button>

      <!-- Backdrop closes the panel on outside click -->
      <div class="sk-header-notif-backdrop" *ngIf="notifOpen" (click)="closeNotifPanel()"></div>

      <!-- Notification center dropdown -->
      <div class="sk-header-notif-panel" *ngIf="notifOpen" role="menu">
        <div class="sk-header-notif-panel-header">
          <mat-icon class="sk-header-notif-panel-icon">notifications</mat-icon>
          <span class="sk-header-notif-panel-title">{{ 'Notifications' | translate }}</span>
          <button
            type="button"
            class="sk-header-notif-markall"
            *ngIf="notifItems.length > 0"
            (click)="markAllNotifRead()"
          >{{ 'Mark all read' | translate }}</button>
        </div>
        <div class="sk-header-notif-divider"></div>

        <div class="sk-header-notif-loading" *ngIf="notifLoading">{{ 'Loading...' | translate }}</div>

        <div class="sk-header-notif-empty" *ngIf="!notifLoading && notifItems.length === 0">
          <mat-icon>notifications_none</mat-icon>
          <span>{{ 'You have no notifications' | translate }}</span>
        </div>

        <button
          *ngFor="let item of notifItems"
          type="button"
          class="sk-header-notif-item"
          [class.sk-header-notif-item--unread]="item.Category === 'event' && !item.IsRead"
          [attr.data-sev]="notifSeverity(item)"
          (click)="onNotifClick(item)"
          role="menuitem"
        >
          <span class="sk-header-notif-item-rail" aria-hidden="true"></span>
          <span class="sk-header-notif-item-count" *ngIf="notifCount(item) !== null">{{ notifCount(item) }}</span>
          <mat-icon class="sk-header-notif-item-icon" *ngIf="notifCount(item) === null">{{ notifIcon(item) }}</mat-icon>
          <span class="sk-header-notif-item-body">
            <span class="sk-header-notif-item-title">{{ notifLabel(item) }}</span>
            <span class="sk-header-notif-item-where" *ngIf="notifWhere(item)">in {{ notifWhere(item) }}</span>
          </span>
          <span class="sk-header-notif-item-dot" *ngIf="item.Category === 'event' && !item.IsRead"></span>
          <!-- Events dismiss by marking read; tasks dismiss by persisting a signature-based
               row that auto-invalidates when the underlying set changes (new pending/escalation
               re-surfaces the counter). Event rows with a null Id have no server target so
               keep the button hidden. -->
          <span
            *ngIf="(item.Category === 'event' && item.Id != null) || (item.Category === 'task' && item.Type)"
            class="sk-header-notif-item-dismiss"
            role="button"
            [attr.aria-label]="'Dismiss notification' | translate"
            (click)="dismissNotif(item, $event)"
          >
            <mat-icon>close</mat-icon>
          </span>
        </button>
      </div>
    </div>

    <!-- Profile menu -->
    <div class="sk-header-profile-wrap">
      <div
        class="sk-header-profile-menu"
        [class.sk-header-profile-menu--active]="profileMenuOpen"
        (click)="toggleProfileMenu()"
        role="button"
        tabindex="0"
        (keydown.enter)="toggleProfileMenu()"
        (keydown.space)="toggleProfileMenu(); $event.preventDefault()"
      >
        <div class="sk-header-profile-inner">
          <ngx-avatar *ngIf="!userProfile" size="32" class="sk-header-avatar sk-header-avatar-initials"
            name="{{ accessTokenService.getUserName() ? accessTokenService.getUserName() : '' }}">
            {{ userInitials }}
          </ngx-avatar>
          <span *ngIf="userProfile" class="sk-header-avatar">
            <img [src]="userProfile" [alt]="'Profile picture' | translate" />
          </span>
          <span class="sk-header-profile-name">{{ accessTokenService.getUserName() ? accessTokenService.getUserName() : '' }}</span>
          <mat-icon
            class="sk-header-profile-chevron"
            [class.sk-header-profile-chevron--open]="profileMenuOpen"
          >keyboard_arrow_down</mat-icon>
        </div>
      </div>
      <div class="sk-header-profile-dropdown-backdrop" *ngIf="profileMenuOpen" (click)="closeProfileMenu()"></div>
      <div class="sk-header-profile-dropdown" *ngIf="profileMenuOpen" role="menu">
        <div class="sk-header-profile-dropdown-header">
          <mat-icon class="sk-header-profile-dropdown-icon">account_circle</mat-icon>
          <span>{{ 'My Account' | translate }}</span>
        </div>
        <div class="sk-header-profile-dropdown-divider"></div>
        <button
          *ngFor="let action of profileMenus"
          type="button"
          class="sk-header-profile-dropdown-item"
          [class.sk-header-profile-dropdown-item--logout]="action.FieldName === 'menu1Logout'"
          (click)="performAction(action); closeProfileMenu()"
          role="menuitem"
        >
          <mat-icon class="sk-header-profile-dropdown-item-icon">{{ getProfileMenuIcon(action.FieldName) }}</mat-icon>
          <span class="sk-header-profile-dropdown-item-label">{{ action.Title | translate }}</span>
        </button>
      </div>
    </div>

  </div>
</div>
